import React from "react";

/**
 * The four "+" registration marks a `.blueprint` frame draws just outside its
 * corners (ADR 0061 §1). Decorative: hidden from assistive technology, and
 * never focusable. Place it as the first children of an element that carries
 * the `blueprint` class.
 */
export function BlueprintCorners() {
    return (
        <>
            <i className="corner tl" aria-hidden="true"/>
            <i className="corner tr" aria-hidden="true"/>
            <i className="corner bl" aria-hidden="true"/>
            <i className="corner br" aria-hidden="true"/>
        </>
    );
}

export default BlueprintCorners;
